/**
 * Groups a set of form fields under a section title + description.
 * Visual: small serif heading, muted description, and a grid of children.
 */
export default function FormSection({ title, description, children, columns = 1, className = "" }) {
  const gridClass = columns === 2 ? "md:grid-cols-2" : "md:grid-cols-1";
  return (
    <section className={`space-y-5 ${className}`}>
      <header>
        <h3 className="font-display text-xl font-semibold text-foreground">{title}</h3>
        {description && (
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
        )}
      </header>
      <div className={`grid gap-5 ${gridClass}`}>{children}</div>
    </section>
  );
}
